module.exports = __webpack_public_path__ + "static/media/29EUNOG16.e2198873.jpg";